import script from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=5e58281c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e58281c"]])

export default __exports__